import {createReducer} from 'redux-act';
import {
  CANCEL_DELIVERY_ORDER,
  CHANGE_STATUS,
  CHANGE_STATUS_SUCCESS,
  GET_DELIVERY_STATUS_SUCCESS,
  GET_DISPATCH_INFO,
  GET_DISPATCH_INFO_SUCCESS,
  GET_ORDER,
  GET_ORDER_SUCCESS,
  OPEN_CANCEL_DELIVERY_ORDER_MODAL,
  OPEN_CANCEL_DELIVERY_ORDER_RESULT_MODAL,
  ORDER_UNMOUNT,
  SET_LOADING_CANCELLATION
} from './action';
import {ORDER} from '../../../helpers/constants/orders';
import {calculateOverdueAndFuture} from '../../../helpers/functionUtils/ordersUtils';

const initialState = () => ({
  order: {
    orderInfo: {
      items: []
    }
  },
  dispatchInfo: null,
  locationData: null,
  ordersLoading: false,
  changeStatusLoading: null,
  deliveryStatus: {
    status: null,
    lastUpdateDate: null
  },
  isOpenCancelDeliveryOrderModal: false,
  loadingCancellation: false,
  deliveryCancellationResult: {
    isOpenModal: false,
    message: null
  }
});

const orderDetailsReducer = createReducer(
  {
    [CHANGE_STATUS]: (state) => ({
      ...state,
      changeStatusLoading: true
    }),
    [CHANGE_STATUS_SUCCESS]: (state, payload) => ({
      ...state,
      order: {...state.order, [ORDER.ORDER_STATUS]: payload},
      changeStatusLoading: false
    }),
    [GET_ORDER]: (state) => ({
      ...state,
      loading: true
    }),
    [ORDER_UNMOUNT]: (state) => ({
      ...state,
      ...initialState(),
      currentLocationTimezone: state.currentLocationTimezone
    }),
    [GET_ORDER_SUCCESS]: (state, payload) => {
      return {
        ...state,
        order: calculateOverdueAndFuture(payload),
        loading: false
      };
    },
    [GET_DISPATCH_INFO]: (state) => ({
      ...state
    }),
    [GET_DISPATCH_INFO_SUCCESS]: (state, {support_number, order_id}) => {
      const info = {};
      info.DeliverySupportPhoneNumber = support_number;
      info.DeliveryReferenceNumber = order_id;
      return {
        ...state,
        dispatchInfo: info
      };
    },
    [GET_DELIVERY_STATUS_SUCCESS]: (state, payload) => ({
      ...state,
      deliveryStatus: payload
    }),
    [OPEN_CANCEL_DELIVERY_ORDER_MODAL]: (state, payload) => ({
      ...state,
      isOpenCancelDeliveryOrderModal: payload
    }),
    [SET_LOADING_CANCELLATION]: (state, payload) => ({
      ...state,
      loadingCancellation: payload
    }),
    [CANCEL_DELIVERY_ORDER]: (state) => ({
      ...state,
      loadingCancellation: true
    }),
    [OPEN_CANCEL_DELIVERY_ORDER_RESULT_MODAL]: (state, payload) => ({
      ...state,
      deliveryCancellationResult: payload,
      loadingCancellation: false
    })
  },
  initialState()
);

export default orderDetailsReducer;
